import { render, staticRenderFns } from "./SearchBrands.vue?vue&type=template&id=e45173ea"
import script from "./SearchBrands.vue?vue&type=script&lang=js"
export * from "./SearchBrands.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports